import React, { useState } from 'react';
import HeroModule from './modules/HeroModule';
import AboutModule from './modules/AboutModule';
import MenusModule from './modules/MenusModule';
import ContentsModule from './modules/ContentsModule';
import SettingsModule from './modules/SettingsModule';
import ProductsModule from './modules/ProductsModule';
import ServicesModule from './modules/ServicesModule';
import TrainingsModule from './modules/TrainingsModule';
import PartnersModule from './modules/PartnersModule';
import TeamModule from './modules/TeamModule';
import TestimonialsModule from './modules/TestimonialsModule';
import EventsModule from './modules/EventsModule';
import WhyUsModule from './modules/WhyUsModule';
import CareersModule from './modules/CareersModule';

const AdminCMS = () => {
  const [activeTab, setActiveTab] = useState('hero');
  const [cmsSubTab, setCmsSubTab] = useState('products');

  const mainTabs = [
    { id: 'hero', label: '🎨 Hero Slides', icon: 'fas fa-images' },
    { id: 'about', label: '📖 About Us', icon: 'fas fa-info-circle' },
    { id: 'cms', label: '📦 CMS Manager', icon: 'fas fa-database' },
    { id: 'menus', label: '📋 Menus', icon: 'fas fa-bars' },
    { id: 'contents', label: '📄 Content Manager', icon: 'fas fa-file-alt' },
    { id: 'settings', label: '⚙️ Settings', icon: 'fas fa-cog' }
  ];

  const cmsModules = [
    { id: 'products', label: '📦 Products', icon: 'fas fa-box', component: ProductsModule },
    { id: 'services', label: '⚙️ Services', icon: 'fas fa-cogs', component: ServicesModule },
    { id: 'trainings', label: '🎓 Trainings', icon: 'fas fa-graduation-cap', component: TrainingsModule },
    { id: 'partners', label: '🤝 Partners', icon: 'fas fa-handshake', component: PartnersModule },
    { id: 'team', label: '👥 Team', icon: 'fas fa-users', component: TeamModule },
    { id: 'testimonials', label: '💬 Testimonials', icon: 'fas fa-comment', component: TestimonialsModule },
    { id: 'events', label: '📅 Events', icon: 'fas fa-calendar', component: EventsModule },
    { id: 'whyus', label: '⭐ Why Us', icon: 'fas fa-star', component: WhyUsModule },
    { id: 'careers', label: '💼 Careers', icon: 'fas fa-briefcase', component: CareersModule }
  ];

  const renderContent = () => {
    switch(activeTab) {
      case 'hero':
        return <HeroModule />;
      case 'about':
        return <AboutModule />;
      case 'cms':
        const ActiveComponent = cmsModules.find(m => m.id === cmsSubTab)?.component;
        return ActiveComponent ? <ActiveComponent /> : <ProductsModule />;
      case 'menus':
        return <MenusModule />;
      case 'contents':
        return <ContentsModule />;
      case 'settings':
        return <SettingsModule />;
      default:
        return <HeroModule />;
    }
  };

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ color: '#0A192F', fontSize: '1.8rem', marginBottom: '0.5rem' }}>Content Management System</h1>
        <p style={{ color: '#5A6E7F' }}>Complete website content management - All sections fully integrated</p>
      </div>

      {/* Main Navigation Tabs */}
      <div style={{ 
        display: 'flex', 
        gap: '0.25rem', 
        borderBottom: '2px solid #E2E8F0', 
        marginBottom: '2rem', 
        flexWrap: 'wrap',
        paddingBottom: '0'
      }}>
        {mainTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => {
              setActiveTab(tab.id);
              if (tab.id === 'cms') setCmsSubTab('products');
            }}
            style={{
              padding: '0.75rem 1.5rem',
              background: activeTab === tab.id ? '#2C7A7B' : 'transparent',
              color: activeTab === tab.id ? 'white' : '#5A6E7F',
              border: 'none',
              borderRadius: '8px 8px 0 0',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '0.9rem',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <i className={tab.icon} style={{ fontSize: '1rem' }} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* CMS Sub Navigation Tabs */}
      {activeTab === 'cms' && (
        <div style={{ 
          display: 'flex', 
          gap: '0.5rem', 
          flexWrap: 'wrap', 
          marginBottom: '2rem',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #E2E8F0'
        }}>
          {cmsModules.map((module) => (
            <button
              key={module.id}
              onClick={() => setCmsSubTab(module.id)}
              style={{
                padding: '0.5rem 1rem',
                background: cmsSubTab === module.id ? '#2C7A7B' : 'transparent',
                color: cmsSubTab === module.id ? 'white' : '#5A6E7F',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: '0.85rem',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <i className={module.icon} style={{ fontSize: '0.85rem' }} />
              {module.label}
            </button>
          ))}
        </div>
      )}

      {/* Content Area */}
      <div style={{ marginTop: '2rem' }}>
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminCMS;